<template>
    <div>
        <div class="bg-white px-3 py-1 mt-9" v-loading="loading">
            <div class="flex items-center justify-between" style="height: 40px">
                <div class="h-full flex items-center">
                    <div class="flex items-center mr-8">
                        <div class="table__search-input-wrapper">
                            <div @click="showFilterModal = true" class="cursor-pointer"><search-drop-down-icon /></div>
                            <input type="text" class="table__search-input" placeholder="" :disabled="true"
                                v-model="query" />
                            <span class="pr-2">
                            </span>
                        </div>
                    </div>
                </div>

                <primary-button buttonText="Create New Booking" :loading="false" @click="createBooking" />
            </div>

            <div class="py-5 bg-white w-100 flex items-center justify-center mt-5" style="height: 60vh"
                v-if="loadingConsolidations">
                <loader />
            </div>

            <div v-else-if="!(shipments.shipments && shipments.shipments.length)"
                class="bg-white w-100 flex justify-center flex-col items-center p-5 my-5">
                <empty-table-icon />
                <p class="font-semibold pt-3 pb-5">No Items found!</p>
            </div>

            <div v-else>
                <div class="table-wrapper" id="table-wrapper">
                    <table class="custom-table responsive-table">
                        <thead>
                            <tr>
                                <th class="width-xs">
                                    <base-checkbox v-model="shouldSelectAllBookings" type="checkbox" class="checkbox" />
                                </th>
                                <th v-for="header in activeHeaders" :key="header">{{ header.name }}</th>

                                <th class="relative width-xs" tabindex="-1">
                                    <span class="cursor-pointer" @click="isTableFilter = !isTableFilter">
                                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <g opacity="0.7">
                                                <path fill-rule="evenodd" clip-rule="evenodd"
                                                    d="M4 0.130371C5.86384 0.130371 7.42994 1.46057 7.87398 3.26081H16V5.34776H7.87398C7.42994 7.148 5.86384 8.4782 4 8.4782C1.79086 8.4782 0 6.60947 0 4.30428C0 1.9991 1.79086 0.130371 4 0.130371ZM4 6.39124C5.10457 6.39124 6 5.45688 6 4.30428C6 3.15169 5.10457 2.21733 4 2.21733C2.89543 2.21733 2 3.15169 2 4.30428C2 5.45688 2.89543 6.39124 4 6.39124Z"
                                                    fill="#383F51" />
                                                <path fill-rule="evenodd" clip-rule="evenodd"
                                                    d="M14 17.8695C12.1362 17.8695 10.5701 16.5393 10.126 14.7391H2V12.6521H10.126C10.5701 10.8519 12.1362 9.52168 14 9.52168C16.2091 9.52168 18 11.3904 18 13.6956C18 16.0008 16.2091 17.8695 14 17.8695ZM14 15.7825C15.1046 15.7825 16 14.8482 16 13.6956C16 12.543 15.1046 11.6086 14 11.6086C12.8954 11.6086 12 12.543 12 13.6956C12 14.8482 12.8954 15.7825 14 15.7825Z"
                                                    fill="#383F51" />
                                            </g>
                                        </svg></span>

                                </th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr v-for="(consolidation) in shipments.shipments" :key="consolidation.id"
                                class="cursor-pointer">
                                <td>
                                    <base-checkbox :value="consolidation.id"
                                        @change="changedValue($event, consolidation)" v-model="selectedShipment" />
                                </td>

                                <td v-for="header in activeHeaders" :key="header">
                                    <span v-if="header.name === 'ORIGIN'">
                                        {{ consolidation.originationTerminal ? consolidation.originationTerminal.name :
                                            "N/A" }},<br />
                                        {{ consolidation.originationTerminal ? consolidation.originationTerminal.state :
                                            "N/A" }}
                                    </span>

                                    <span :title="recieverAddress(consolidation)" v-else-if="header.name === 'Destination'">
                                        {{ recieverAddress(consolidation) }}
                                    </span>

                                    <span v-else-if="header.name === 'Weight'">
                                        {{ getLoadWeight(consolidation) }}
                                    </span>

                                    <span v-else-if="header.name === 'Service/EDD'">
                                        {{ consolidation && consolidation.shippingService ?
                                            consolidation.shippingService.schedule[0] : "N/A" }}<br />
                                    </span>

                                    <span v-else-if="header.name === 'Shipping ID'">
                                        {{ consolidation && consolidation.shippingReference }}<br />
                                        <span class=" text-gray-400">{{ changeTimeFormat(consolidation.createdAt)
                                            }}</span>
                                    </span>





                                    <!-- Special case for Status -->
                                    <span v-else-if="header.name === 'Status'">
                                        <button :title="consolidation.deliveryStatus.replace(/_/g, ' ')"
                                            :class="['order_status']"
                                            :style="{ ...$_statusColors(consolidation.deliveryStatus) }">{{
                                                consolidation.deliveryStatus.replace(/_/g, ' ').toLowerCase() }}</button>
                                    </span>

                                    <!-- <span v-else-if="header.name === 'Consolidation ID # + Date'">
                                        {{ consolidation?.consolidationReference ?? "N/A" }}
                                        <span class="block w-full opacity-50">{{ consolidation.createdAt ?
                                            consolidation.createdAt.split("T")[0] : "N/A" }}</span>
                                    </span> -->

                                    <span v-else>
                                        {{ getNestedValue(consolidation, headerMap[header.name]) }}
                                    </span>
                                </td>


                                <td>
                                    <el-dropdown>
                                        <button @click="
                                            (selectedID = consolidation.id),
                                            (selectedConsolidation = consolidation)
                                            ">
                                            <vertical-ellipsis />
                                        </button>

                                        <el-dropdown-menu slot="dropdown">
                                            <el-dropdown-item>
                                                <button class="flex items-center">
                                                    <details-icon />
                                                    <span class="ml-2">View</span>
                                                </button>
                                            </el-dropdown-item>
                                            <el-dropdown-item>
                                                <button class="flex items-center" @click="updateStatus(consolidation)">
                                                    <update-icon />
                                                    <span class="ml-2">Update Status</span>
                                                </button>
                                            </el-dropdown-item>
                                        </el-dropdown-menu>
                                    </el-dropdown>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <pagination :total="totalShipment" :pageNumber="pageNumber" @pageNumber="setNumDisplayLocation"
                @pageSize="pageSize" />
            <NewBookinfModal :showModal="showNewBookingModal" @close-modal="showNewBookingModal = false" />
            <ConfirmCreateBooking :openBooking="openBookingModal" :showModal="confirmcreateBookingModal"
                @close-modal="confirmcreateBookingModal = false" />

            <update-status-modal @refetchBooking="refetchBooking" :booking="activeShipment"
                :showmodal="showUpdateStatusModal" @close-modal="showUpdateStatusModal = false" />

            <div class="flex justify-between mt-5">
                <button @click="$store.dispatch('setNewConsolidationLevel', 1)" :loading="loading">Back</button>
                <base-button text="Next" @click="proceed" :loading="loading" :disabled="disabled" />
            </div>
        </div>
    </div>
</template>

<script>
import pagination from "@/components/UI/pagination.vue";
import NewBookinfModal from "@/components/Ondemand/Bookings/modals/NewBookinfModal.vue";
import ConfirmCreateBooking from "../modal/confirm-create-booking.vue"
import { shippingMethods } from "../../../../constant/onboardingType"
import UpdateStatusModal from "../modal/uodate-status-modal.vue";
import moment from "moment";

export default {
    components: {
        pagination,
        NewBookinfModal,
        ConfirmCreateBooking,
        UpdateStatusModal,
    },
    activated() {
        this.getBookings()
    },
    watch: {
        setparams() {
            this.getBookings()
        },
        shouldSelectAllBookings(checked) {
            let setShipment = []
            if (checked) {
                this.shipments.shipments.forEach(element => {
                    setShipment.push(element?.id)
                });
            } else {
                setShipment = []
            }
            this.selectedShipment = setShipment
        },
        getSelcRoute() {
            this.getBookings()
        }
    },
    computed: {
        setparams() {
            return {
                pageSize: this.shipmentPerPage,
                pageNumber: this.pageNumber,
            };
        },
        disabled() {
            return this.selectedShipment.length < 1
        },
        getSelcRoute() {
            return this.$store.getters?.getNewConsolidationSelecetedRoute
        },
        getSelcRouteStr() {
            return this.$store.getters?.getNewConsolidationSelecetedRoute.join(',')
        },
    },
    data() {
        return {
            query: "",
            showFilterModal: false,
            startDate: "",
            endDate: "",
            showNewBookingModal: false,
            confirmcreateBookingModal: false,
            loading: false,
            shipments: {},
            selectedShipment: [],
            selectedID: null,
            shouldSelectAllBookings: false,
            activeShipment: {},
            showUpdateStatusModal: false,
            shipmentPerPage: 10,
            totalShipment: 0,
            pageNumber: 1,
            activeHeaders: [
                { name: "Shipping ID" },
                { name: "Service/EDD" },
                { name: "Weight" },
                { name: "Handling" },
                { name: "Origin" },
                { name: "Destination" },
                { name: "Status" },
            ],
            headerMap: {
                "Shipping ID": '',
                "Service/EDD": '',
                "Weight": "",
                "Handling": '',
                "Origin": 'shipperlocation.address.name',
                "Destination": "",
                "Status": "",
            },
        }
    },
    methods: {
        changeTimeFormat(val) {
            return moment(val).format("DD/MM/YYYY") ?? "";
        },
        pageSize(val) {
            this.shipmentPerPage = val;
        },
        setNumDisplayLocation(val) {
            this.pageNumber = val;
        },
        refetchBooking() {
            this.getBookings();
        },
        updateStatus(shipment) {
            localStorage.setItem("currentShippment", JSON.stringify(shipment));
            this.activeShipment = shipment;
            this.showUpdateStatusModal = true;
        },
        proceed() {
            this.$store.dispatch('setNewConsolidationSelecetedShipment', [...new Set(this.selectedShipment)]);
            this.$store.dispatch('setNewConsolidationLevel', 3)

        },
        isChecked(item) {
            return this.selectedShipment.includes(item.id)
        },
        changedValue(checked, shipment) {
            checked && this.selectedShipment.push(shipment?.id)
            if (!checked) {
                this.selectedShipment = this.selectedShipment.filter((item) => item !== shipment?.id)
            }
        },
        getLoadWeight(booking) {
            const totalWeight = (booking?.shipmentReceiever || []).reduce((sum, order) => {
                const packageWeight = (order?.packagees || []).reduce((pkgSum, pkg) => {
                    return pkgSum + (Number(pkg?.estimatedWeight) * Number(pkg?.quantity || 1));
                }, 0);

                return sum + packageWeight;
            }, 0);

            return totalWeight;
        },
        recieverAddress(booking) {
            let type = booking?.shippingMethod;
            switch (type) {
                case shippingMethods.D2D: {
                    const str = (booking?.shipmentReceiever || []).map((item) => item?.location?.address?.name || "N/A").join(",");
                    return str.length > 100 ? str.substring(0, 100) + "..." : str;
                }

                case shippingMethods.T2T:
                    return booking?.shipmentReceiever?.address?.address || booking?.shipmentReceiever?.address?.name || "N/A"

                default:
                    return booking?.shipmentReceiever?.address?.address || booking?.shipmentReceiever?.address?.name || "N/A"
            }
        },
        getNestedValue(obj, path) {
            const value = path?.split('.').reduce((acc, part) => acc && acc[part], obj);
            return value === null || value === undefined || value === '' ? 'N/A' : value;
        },

        openBookingModal() {
            this.confirmcreateBookingModal = false;
            this.showNewBookingModal = true
        },
        createBooking() {
            this.confirmcreateBookingModal = true
        },
        perPageSize(pageSize) {
            this.pageSize = pageSize
        },
        async getBookings() {
            this.loading = true;
            try {
                let response = await this.$_newGetConsolidationShipments({ shippingServiceId: this.getSelcRouteStr, ...this.setparams });
                this.shipments = response?.data?.data;
                this.totalShipment = response?.data?.data?.totalCount
            } catch (error) {
                // ...code here
            } finally {
                this.loading = false
            }
        }
    },
}
</script>

<style lang="scss" scoped>
.order_status {
    @apply text-xs w-[120px] whitespace-nowrap capitalize text-ellipsis overflow-hidden rounded-2xl py-1.5 px-3
}

#table-wrapper {
    margin: 2rem 0 0;
    overflow-x: auto;
}

.table-wrapper,
.table-wrapper .custom-table {
    transform: rotateX(180deg);
    -ms-transform: rotateX(180deg);
    -webkit-transform: rotateX(180deg);
}

/* width */
.table-wrapper::-webkit-scrollbar {
    cursor: pointer;
    width: 5px;
    height: 8px;
}

/* Track */
.table-wrapper::-webkit-scrollbar-track {
    background: #c4c4c4;
}

/* Handle */
.table-wrapper::-webkit-scrollbar-thumb {
    background: #fab427;
    width: 5px;
    border-radius: 20px;
}

.table-header {}


.custom-table {
    margin-top: 0;
}

th {
    min-width: 10rem;
    color: #19304d;
    opacity: 0.7;
    padding: 0.25rem;
    font-weight: normal;
}

.checkbox {
    display: initial;
    width: 1rem;
    height: 1rem;
}

td {
    background: #ffffff;
    color: var(--primaryblue);
    font-weight: 500;
    border-radius: 2px;
    padding: 0.75rem 0.25rem;
    vertical-align: top;
}

.booking-channel-col {
    width: 15%;
}

.shipping-ref-col {
    width: 13%;
}

.booking-status {
    background: #fae5e7;
    color: #d72638 !important;
    border-radius: 10px;
    padding: 0.5rem;
    font-weight: 500 !important;
    opacity: 1 !important;
}

table {
    border-collapse: separate;
    border-spacing: 0 0.5rem;
}

.table-date {
    width: 12%;
}

.width-xs {
    min-width: 3rem !important;
}
</style>